import React, { useEffect, useState } from "react";

// Mui
import {
  Dialog,
  Button,
  TextField,
  Box,
  Typography,
  Stack,
  MenuItem,
  IconButton,
} from "@mui/material";

// Services
import {
  AdminEntry,
  clearDefaultAdminEntry,
  saveAdminEntry,
} from "../../services/PublishIndiaService";

// Components
import ImageGalleryDialog from "../ImageGalleryDialog/ImageGalleryDialog";
import VideoGalleryDialog from "../VideoGalleryDialog/VideoGalleryDialog";
import PDFMediaDialog from "../PDFMediaDialog/PDFMediaDialog";
import LinkGalleryDialog from "../linkGalleryDialog/linkGalleryDialog";
import Spinner from "../spinner/Spinner";

// Assets
import frameadd from "../../assets/FrameAdd.svg";
import gallery from "../../assets/gallery.svg";
import video1 from "../../assets/videogallery.svg";
import pdf1 from "../../assets/pdfgallery.svg";
import link1 from "../../assets/linkgallery.svg";
import arrowback from "../../assets/arrow_back.svg";
import visiable from "../../assets/visiable.svg";
import edit from "../../assets/edit.svg";
import delete1 from "../../assets/delete.svg";

// Config
import { appConfig } from "../../config/appConfig";

// Styles
import "./PublishIndiaFormDialog.scss";
import { UPLOADTYPE } from "../../models/enums/globalEnums";

interface Catgry {
  id: number;
  name: string;
}
interface PublishIndiaFormDialogProps {
  open: boolean;
  onClose?: () => void;

  fetchData: () => void;
  resetForm: () => void;
  categories: any;
  formData: AdminEntry;
  setFormData: any;
  editingIndex: any;
  setShowForm: any;
  setEditingIndex: any;
  dataList: any;
}

const PublishIndiaFormDialog: React.FC<PublishIndiaFormDialogProps> = ({
  open,
  onClose,
  fetchData,
  resetForm,
  categories,
  formData,
  setFormData,
  editingIndex,
  setShowForm,
  setEditingIndex,
  dataList,
}) => {
  // Media Upload States
  const [selectedThumbnail, setSelectedThumbnail] = useState<File[]>([]);
  const [selectedImages, setSelectedImages] = useState<File[]>([]);
  const [selectedVideos, setSelectedVideos] = useState<File[]>([]);

  // PDF Upload States
  const [selectedPdf, setSelectedPdf] = useState<File[]>([]);
  const [selectedPdf2, setSelectedPdf2] = useState<File[]>([]);
  const [selectedPdf3, setSelectedPdf3] = useState<File[]>([]);

  // Grid Media & Thumbnail States
  const [grid1, setGrid1] = useState<File[]>([]);
  const [gridThumbnail1, setgridThumbnail1] = useState<File[]>([]);

  const [grid2, setGrid2] = useState<File[]>([]);
  const [gridThumbnail2, setgridThumbnail2] = useState<File[]>([]);

  const [grid3, setGrid3] = useState<File[]>([]);
  const [gridThumbnail3, setgridThumbnail3] = useState<File[]>([]);

  const [grid4, setGrid4] = useState<File[]>([]);
  const [gridThumbnail4, setgridThumbnail4] = useState<File[]>([]);

  const [grid5, setGrid5] = useState<File[]>([]);
  const [gridThumbnail5, setgridThumbnail5] = useState<File[]>([]);

  const [grid6, setGrid6] = useState<File[]>([]);
  const [gridThumbnail6, setgridThumbnail6] = useState<File[]>([]);

  const [grid7, setGrid7] = useState<File[]>([]);
  const [gridThumbnail7, setgridThumbnail7] = useState<File[]>([]);

  const [grid8, setGrid8] = useState<File[]>([]);
  const [gridThumbnail8, setgridThumbnail8] = useState<File[]>([]);

  const [grid9, setGrid9] = useState<File[]>([]);
  const [gridThumbnail9, setgridThumbnail9] = useState<File[]>([]);

  // Dialog Visibility States
  const [openImageDialog, setopenImageDialog] = useState(false);
  const [openVideoDialog, setopenVideoDialog] = useState(false);
  const [openPDFDialog, setopenPDFDialog] = useState(false);
  const [openLinkDialog, setopenLinkDialog] = useState(false);

  // Checkbox States
  const [ispdfChecked, setIsPdfChecked] = useState(false);
  const [ispdfChecked2, setIsPdfChecked2] = useState(false);
  const [ispdfChecked3, setIsPdfChecked3] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  // Media Transfer Between Dialogs
  const [oldMedia, setOldMedia] = useState<string>("");
  const [oldThumbnail, setOldThumbnail] = useState<string>("");
  const [gridType, setGridType] = useState("");
  const [newMedia, setNewMedia] = useState<File[]>([]);
  const [newThumbnail, setNewThumbnail] = useState<File[]>([]);
  const [gridIndex, setgridIndex] = useState<number | null>(null);
  const [gridTitle, setgridTitle] = useState("");

  // Misc
  const [error, setError] = useState<string | null>(null);
  const [viderror, setVidError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  /////////////////////handle grid click
  useEffect(() => {
    if (!gridIndex) return;

    if (gridIndex === 1) {
      // alert("1 grid");
      setGrid1(newMedia ?? "");
      setgridThumbnail1(newThumbnail ?? "");
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid1: oldMedia ?? "",
        gridThumbnail1: oldThumbnail ?? "",
        gridType1: gridType ?? "",
        gridIconName1: gridTitle ?? "",
      }));
    } else if (gridIndex === 2) {
      setGrid2(newMedia ?? "");
      setgridThumbnail2(newThumbnail ?? "");
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid2: oldMedia ?? "",
        gridThumbnail2: oldThumbnail ?? "",
        gridType2: gridType ?? "",
        gridIconName2: gridTitle ?? "",
      }));
    } else if (gridIndex === 3) {
      setGrid3(newMedia ?? "");
      setgridThumbnail3(newThumbnail ?? "");
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid3: oldMedia ?? "",
        gridThumbnail3: oldThumbnail ?? "",
        gridType3: gridType ?? "",
        gridIconName3: gridTitle ?? "",
      }));
    } else if (gridIndex === 4) {
      setGrid4(newMedia ?? "");
      setgridThumbnail4(newThumbnail ?? "");
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid4: oldMedia ?? "",
        gridThumbnail4: oldThumbnail ?? "",
        gridType4: gridType ?? "",
        gridIconName4: gridTitle ?? "",
      }));
    } else if (gridIndex === 5) {
      setGrid5(newMedia ?? "");
      setgridThumbnail5(newThumbnail ?? "");
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid5: oldMedia ?? "",
        gridThumbnail5: oldThumbnail ?? "",
        gridType5: gridType ?? "",
        gridIconName5: gridTitle ?? "",
      }));
    } else if (gridIndex === 6) {
      setGrid6(newMedia ?? "");
      setgridThumbnail6(newThumbnail ?? "");
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid6: oldMedia ?? "",
        gridThumbnail6: oldThumbnail ?? "",
        gridType6: gridType ?? "",
        gridIconName6: gridTitle ?? "",
      }));
    } else if (gridIndex === 7) {
      setGrid7(newMedia ?? "");
      setgridThumbnail7(newThumbnail ?? "");
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid7: oldMedia ?? "",
        gridThumbnail7: oldThumbnail ?? "",
        gridType7: gridType ?? "",
        gridIconName7: gridTitle ?? "",
      }));
    } else if (gridIndex === 8) {
      setGrid8(newMedia ?? "");
      setgridThumbnail8(newThumbnail ?? "");
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid8: oldMedia ?? "",
        gridThumbnail8: oldThumbnail ?? "",
        gridType8: gridType ?? "",
        gridIconName8: gridTitle ?? "",
      }));
    } else if (gridIndex === 9) {
      setGrid9(newMedia ?? "");
      setgridThumbnail9(newThumbnail ?? "");
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid9: oldMedia ?? "",
        gridThumbnail9: oldThumbnail ?? "",
        gridType9: gridType ?? "",
        gridIconName9: gridTitle ?? "",
      }));
    }
  }, [
    oldMedia ?? "",
    oldThumbnail ?? "",
    gridType,
    newMedia ?? "",
    newThumbnail ?? "",
  ]);

  /// handlegrid  //////////////////
  const reset = () => {
    setOldMedia("");
    setOldThumbnail("");
    setNewMedia([]);
    setNewThumbnail([]);
    setgridIndex(0);
    setGridType("");
  };

  const handleGridClick = (index: number) => {
    let temp = "temp";

    reset();
    if (index === 1) {
      setNewMedia(grid1);
      setNewThumbnail(gridThumbnail1);

      setOldMedia(
        Array.isArray(formData.grid1) ? formData.grid1[0] || "" : formData.grid1
      );
      setOldThumbnail(
        Array.isArray(formData.gridThumbnail1)
          ? formData.gridThumbnail1[0] || ""
          : formData.gridThumbnail1
      );
      setgridTitle(formData.gridIconName1);
      temp = formData.gridType1;
    } else if (index === 2) {
      setNewMedia(grid2);
      setNewThumbnail(gridThumbnail2);
      setGridType(formData.gridType2);
      setOldMedia(
        Array.isArray(formData.grid2) ? formData.grid2[0] || "" : formData.grid2
      );
      setOldThumbnail(
        Array.isArray(formData.gridThumbnail2)
          ? formData.gridThumbnail2[0] || ""
          : formData.gridThumbnail2
      );
      temp = formData.gridType2;
      setgridTitle(formData.gridIconName2);
    } else if (index === 3) {
      setNewMedia(grid3);
      setNewThumbnail(gridThumbnail3);
      setGridType(formData.gridType3);
      setgridTitle(formData.gridIconName3);
      setOldMedia(
        Array.isArray(formData.grid3) ? formData.grid3[0] || "" : formData.grid3
      );
      setOldThumbnail(
        Array.isArray(formData.gridThumbnail3)
          ? formData.gridThumbnail3[0] || ""
          : formData.gridThumbnail3
      );
      temp = formData.gridType3;
    } else if (index === 4) {
      setNewMedia(grid4);
      setNewThumbnail(gridThumbnail4);
      setGridType(formData.gridType4);
      setgridTitle(formData.gridIconName4);
      setOldMedia(
        Array.isArray(formData.grid4) ? formData.grid4[0] || "" : formData.grid4
      );
      setOldThumbnail(
        Array.isArray(formData.gridThumbnail4)
          ? formData.gridThumbnail4[0] || ""
          : formData.gridThumbnail4
      );
      temp = formData.gridType4;
      // setopenPDFDialog(true);
    } else if (index === 5) {
      setNewMedia(grid5);
      setNewThumbnail(gridThumbnail5);
      setgridTitle(formData.gridIconName5);
      setGridType(formData.gridType5);
      setOldMedia(
        Array.isArray(formData.grid5) ? formData.grid5[0] || "" : formData.grid5
      );
      setOldThumbnail(
        Array.isArray(formData.gridThumbnail5)
          ? formData.gridThumbnail5[0] || ""
          : formData.gridThumbnail5
      );
      temp = formData.gridType5;
    } else if (index === 6) {
      setNewMedia(grid6);
      setNewThumbnail(gridThumbnail6);
      setGridType(formData.gridType6);
      setgridTitle(formData.gridIconName6);
      setOldMedia(
        Array.isArray(formData.grid6) ? formData.grid6[0] || "" : formData.grid6
      );
      setOldThumbnail(
        Array.isArray(formData.gridThumbnail6)
          ? formData.gridThumbnail6[0] || ""
          : formData.gridThumbnail6
      );
      temp = formData.gridType6;
    } else if (index === 7) {
      setNewMedia(grid7);
      setNewThumbnail(gridThumbnail7);
      setGridType(formData.gridType7);
      setgridTitle(formData.gridIconName7);
      setOldMedia(
        Array.isArray(formData.grid7) ? formData.grid7[0] || "" : formData.grid7
      );
      setOldThumbnail(
        Array.isArray(formData.gridThumbnail7)
          ? formData.gridThumbnail7[0] || ""
          : formData.gridThumbnail7
      );
      temp = formData.gridType7;
    } else if (index === 8) {
      setNewMedia(grid8);
      setNewThumbnail(gridThumbnail8);
      setGridType(formData.gridType8);
      setgridTitle(formData.gridIconName8);
      setOldMedia(
        Array.isArray(formData.grid8) ? formData.grid8[0] || "" : formData.grid8
      );
      setOldThumbnail(
        Array.isArray(formData.gridThumbnail8)
          ? formData.gridThumbnail8[0] || ""
          : formData.gridThumbnail8
      );
      temp = formData.gridType8;
    } else if (index === 9) {
      setNewMedia(grid9);
      setNewThumbnail(gridThumbnail9);
      setGridType(formData.gridType9);
      setgridTitle(formData.gridIconName9);
      setOldMedia(
        Array.isArray(formData.grid9) ? formData.grid9[0] || "" : formData.grid9
      );
      setOldThumbnail(
        Array.isArray(formData.gridThumbnail9)
          ? formData.gridThumbnail9[0] || ""
          : formData.gridThumbnail9
      );
      temp = formData.gridType9;
    }
    setGridType(temp);
    setgridIndex(index);

    if (temp === UPLOADTYPE.IMAGES) {
      setopenImageDialog(true);
    } else if (temp === UPLOADTYPE.VIDEO) {
      setopenVideoDialog(true);
    } else if (temp === UPLOADTYPE.PDF) {
      setopenPDFDialog(true);
    } else if (temp === UPLOADTYPE.LINK) {
      setopenLinkDialog(true);
    }
  };

  //Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (value.length > 120) {
      return; // prevent updating formData if length exceeds 120
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  //handle save
  const handleSave = async () => {
    if (!formData.category.trim()) {
      alert("Category is required!");
      return;
    }

    setLoading(true);
    try {
      const response = await saveAdminEntry(
        formData,
        selectedImages,
        selectedVideos,
        selectedThumbnail,
        editingIndex,
        appConfig.serviceUrls.saveIndiaEntries,
        selectedPdf,
        selectedPdf2,
        selectedPdf3,
        ispdfChecked,
        ispdfChecked2,
        ispdfChecked3,
        isChecked,
        grid1,
        grid2,
        grid3,
        grid4,
        grid5,
        grid6,
        grid7,
        grid8,
        grid9,
        gridThumbnail1,
        gridThumbnail2,
        gridThumbnail3,
        gridThumbnail4,
        gridThumbnail5,
        gridThumbnail6,
        gridThumbnail7,
        gridThumbnail8,
        gridThumbnail9
      );

      if (!response.ok) throw new Error("Failed to save data");

      alert("Data saved successfully");
      fetchData();
      resetForm();
      (document.getElementById("imageUpload") as HTMLInputElement).value = "";
      (document.getElementById("videoUpload") as HTMLInputElement).value = "";

      setShowForm(false);
    } catch (error) {
      console.error("Error saving data:", error);
      // alert(`Failed to save data: ${error}`);
    } finally {
      setLoading(false);
    }
    handleCancel();
    reset();
  };

  // handle cancel
  const handleCancel = () => {
    setShowForm(false);
    setError(null);
    setVidError(null);
    setSelectedImages([]);
    setSelectedVideos([]);
    setEditingIndex(null);
    setSelectedThumbnail([]);

    setSelectedPdf([]);
    setSelectedPdf2([]);
    setSelectedPdf3([]);

    setIsPdfChecked(false);
    setIsPdfChecked2(false);
    setIsPdfChecked3(false);
    setIsChecked(false);
    reset();
  };
  const handleClear = () => {
    if (!window.confirm("Are you sure want to clear this entry?")) return;
    setGrid1([]);
    setGrid2([]);
    setGrid3([]);
    setGrid4([]);
    setGrid5([]);
    setGrid6([]);
    setGrid7([]);
    setGrid8([]);
    setGrid9([]);
    setgridThumbnail1([]);
    setgridThumbnail2([]);
    setgridThumbnail3([]);
    setgridThumbnail4([]);
    setgridThumbnail5([]);
    setgridThumbnail6([]);
    setgridThumbnail7([]);
    setgridThumbnail8([]);
    setgridThumbnail9([]);
    const clearEntry = clearDefaultAdminEntry(formData.id, formData.category);
    setFormData(clearEntry);
  };
  const handleClearGridByID = (index: number) => {
    if (!window.confirm("Are you sure want to delete this entry?")) return;
    // alert(index);

    if (index === 1) {
      setGrid1([]);
      setgridThumbnail1([]);
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid1: "",
        gridThumbnail1: "",
        gridType1: "",
      }));
    } else if (index === 2) {
      setGrid2([]);
      setgridThumbnail2([]);
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid2: "",
        gridThumbnail2: "",
        gridType2: "",
      }));
    } else if (index === 3) {
      setGrid3([]);
      setgridThumbnail3([]);
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid3: "",
        gridThumbnail3: "",
        gridType3: "",
      }));
    } else if (index === 4) {
      setGrid4([]);
      setgridThumbnail4([]);
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid4: "",
        gridThumbnail4: "",
        gridType4: "",
      }));
    } else if (index === 5) {
      setGrid5([]);
      setgridThumbnail5([]);
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid5: "",
        gridThumbnail5: "",
        gridType5: "",
      }));
    } else if (index === 6) {
      setGrid6([]);
      setgridThumbnail6([]);
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid6: "",
        gridThumbnail6: "",
        gridType6: "",
      }));
    } else if (index === 7) {
      setGrid7([]);
      setgridThumbnail7([]);
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid7: "",
        gridThumbnail7: "",
        gridType7: "",
      }));
    } else if (index === 8) {
      setGrid8([]);
      setgridThumbnail8([]);
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid8: "",
        gridThumbnail8: "",
        gridType8: "",
      }));
    } else if (index === 9) {
      setGrid9([]);
      setgridThumbnail9([]);
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        grid9: "",
        gridThumbnail9: "",
        gridType9: "",
      }));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "90%",
          height: "95%",
        },
      }}
    >
      {/* header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#F7F7F7",
          padding: "15px 10px", // Optional: improves appearance
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <IconButton
            color="primary"
            size="small"
            onClick={handleCancel}
            className="custom-icon-button"
          >
            <img src={arrowback} alt="visible" className="custom-icon" />
          </IconButton>

          <Typography className="custom-icon-text">
            {editingIndex === -1
              ? "View India Level DATA"
              : editingIndex !== null
              ? "Edit India Level DATA"
              : "Add India Level Data"}
          </Typography>
        </Box>

        <Box></Box>
      </Box>

      {/* body //////////////////////*/}
      {loading ? (
        <>
          {" "}
          <Spinner></Spinner>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            background: "#FFF",
            padding: "50px 16px",
          }}
        >
          {/* 1st box */}
          <Box>
            <TextField
              select
              disabled={editingIndex !== null}
              label="Category"
              size="small"
              name="category"
              value={formData.category}
              onChange={(e) =>
                setFormData({ ...formData, category: e.target.value })
              }
              className="custom-select"
            >
              {categories.map((cat: Catgry) => (
                <MenuItem key={cat.id} value={cat.id}>
                  {cat.name}
                </MenuItem>
              ))}
            </TextField>
            <Box sx={{ paddingBottom: "35px" }} />

            <Typography>
              {" "}
              <b>Bullet Point </b> (Maximum of three bullet points with 120
              characters each)
            </Typography>
            <Box sx={{ paddingBottom: "6px" }} />
            <TextField
              label="Bullet point 1"
              name="description"
              value={formData.description}
              onChange={handleChange}
              multiline
              disabled={editingIndex === -1}
              rows={2}
              className="custom-select"
            />
            <Box sx={{ paddingBottom: "20px" }} />
            <TextField
              label="Bullet point 2"
              name="description2"
              value={formData.description2}
              onChange={handleChange}
              multiline
              rows={2}
              disabled={editingIndex === -1}
              className="custom-select"
            />
            <Box sx={{ paddingBottom: "20px" }} />
            <TextField
              label="Bullet point 3"
              name="description3"
              value={formData.description3}
              onChange={handleChange}
              multiline
              disabled={editingIndex === -1}
              rows={2}
              className="custom-select"
            />
          </Box>
          {/* 2nd Box */}
          <Box>
            <Typography className="grid-text">
              Add Images , Video or .PDF
            </Typography>
            <Box sx={{ marginTop: "10px" }} />
            <Box className="gridContainer">
              {/* 1st grid Box */}
              <Box>
                <Box className="gridItem">
                  {formData.gridType1 === null ||
                  formData.gridType1 === "" ||
                  formData.gridType1 === "null" ? (
                    <IconButton
                      className="centerButton"
                      onClick={() => handleGridClick(1)}
                    >
                      <img
                        src={frameadd}
                        alt="visible"
                        className="custom-icon"
                      />
                    </IconButton>
                  ) : (
                    (() => {
                      let imgmedia = gallery;
                      if (formData.gridType1 === UPLOADTYPE.PDF)
                        imgmedia = pdf1;
                      else if (formData.gridType1 === UPLOADTYPE.VIDEO)
                        imgmedia = video1;
                      else if (formData.gridType1 === UPLOADTYPE.LINK)
                        imgmedia = link1;

                      return (
                        <>
                          <Box className="centeredContent">
                            <img
                              src={imgmedia}
                              alt="visible"
                              className="custom-gallery"
                            />
                          </Box>
                          {editingIndex !== -1 ? (
                            <>
                              <IconButton
                                className="editButton"
                                onClick={() => handleGridClick(1)}
                              >
                                <img src={edit} alt="edit" className="icon" />
                              </IconButton>
                              <IconButton
                                className="deleteButton"
                                onClick={() => handleClearGridByID(1)}
                              >
                                <img
                                  src={delete1}
                                  alt="delete"
                                  className="icon"
                                />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              className="viewButton"
                              onClick={() => handleGridClick(1)}
                            >
                              <img
                                src={visiable}
                                alt="visible"
                                className="icon"
                              />
                            </IconButton>
                          )}
                        </>
                      );
                    })()
                  )}
                </Box>
              </Box>

              {/* 2nd Box */}
              <Box>
                <Box className="gridItem">
                  {formData.gridType2 === null ||
                  formData.gridType2 === "" ||
                  formData.gridType2 === "null" ? (
                    <IconButton
                      className="centerButton"
                      onClick={() => handleGridClick(2)}
                    >
                      <img
                        src={frameadd}
                        alt="visible"
                        className="custom-icon"
                      />
                    </IconButton>
                  ) : (
                    (() => {
                      let imgmedia = gallery;
                      if (formData.gridType2 === UPLOADTYPE.PDF)
                        imgmedia = pdf1;
                      else if (formData.gridType2 === UPLOADTYPE.VIDEO)
                        imgmedia = video1;
                      else if (formData.gridType2 === UPLOADTYPE.LINK)
                        imgmedia = link1;

                      return (
                        <>
                          <Box className="centeredContent">
                            <img
                              src={imgmedia}
                              alt="visible"
                              className="custom-gallery"
                            />
                          </Box>
                          {editingIndex !== -1 ? (
                            <>
                              <IconButton
                                className="editButton"
                                onClick={() => handleGridClick(2)}
                              >
                                <img src={edit} alt="edit" className="icon" />
                              </IconButton>
                              <IconButton
                                className="deleteButton"
                                onClick={() => handleClearGridByID(2)}
                              >
                                <img
                                  src={delete1}
                                  alt="delete"
                                  className="icon"
                                />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              className="viewButton"
                              onClick={() => handleGridClick(2)}
                            >
                              <img
                                src={visiable}
                                alt="visible"
                                className="icon"
                              />
                            </IconButton>
                          )}
                        </>
                      );
                    })()
                  )}
                </Box>
              </Box>

              {/* 3rd Box */}
              <Box>
                <Box className="gridItem">
                  {formData.gridType3 === null ||
                  formData.gridType3 === "" ||
                  formData.gridType3 === "null" ? (
                    <IconButton
                      className="centerButton"
                      onClick={() => handleGridClick(3)}
                    >
                      <img
                        src={frameadd}
                        alt="visible"
                        className="custom-icon"
                      />
                    </IconButton>
                  ) : (
                    (() => {
                      let imgmedia = gallery;
                      if (formData.gridType3 === UPLOADTYPE.PDF)
                        imgmedia = pdf1;
                      else if (formData.gridType3 === UPLOADTYPE.VIDEO)
                        imgmedia = video1;
                      else if (formData.gridType3 === UPLOADTYPE.LINK)
                        imgmedia = link1;

                      return (
                        <>
                          <Box className="centeredContent">
                            <img
                              src={imgmedia}
                              alt="visible"
                              className="custom-gallery"
                            />
                          </Box>
                          {editingIndex !== -1 ? (
                            <>
                              <IconButton
                                className="editButton"
                                onClick={() => handleGridClick(3)}
                              >
                                <img src={edit} alt="edit" className="icon" />
                              </IconButton>
                              <IconButton
                                className="deleteButton"
                                onClick={() => handleClearGridByID(3)}
                              >
                                <img
                                  src={delete1}
                                  alt="delete"
                                  className="icon"
                                />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              className="viewButton"
                              onClick={() => handleGridClick(3)}
                            >
                              <img
                                src={visiable}
                                alt="visible"
                                className="icon"
                              />
                            </IconButton>
                          )}
                        </>
                      );
                    })()
                  )}
                </Box>
              </Box>
              {/* 4th Box */}
              <Box>
                <Box className="gridItem">
                  {formData.gridType4 === null ||
                  formData.gridType4 === "" ||
                  formData.gridType4 === "null" ? (
                    <IconButton
                      className="centerButton"
                      onClick={() => handleGridClick(4)}
                    >
                      <img
                        src={frameadd}
                        alt="visible"
                        className="custom-icon"
                      />
                    </IconButton>
                  ) : (
                    (() => {
                      let imgmedia = gallery;
                      if (formData.gridType4 === UPLOADTYPE.PDF)
                        imgmedia = pdf1;
                      else if (formData.gridType4 === UPLOADTYPE.VIDEO)
                        imgmedia = video1;
                      else if (formData.gridType4 === UPLOADTYPE.LINK)
                        imgmedia = link1;

                      return (
                        <>
                          <Box className="centeredContent">
                            <img
                              src={imgmedia}
                              alt="visible"
                              className="custom-gallery"
                            />
                          </Box>
                          {editingIndex !== -1 ? (
                            <>
                              <IconButton
                                className="editButton"
                                onClick={() => handleGridClick(4)}
                              >
                                <img src={edit} alt="edit" className="icon" />
                              </IconButton>
                              <IconButton
                                className="deleteButton"
                                onClick={() => handleClearGridByID(4)}
                              >
                                <img
                                  src={delete1}
                                  alt="delete"
                                  className="icon"
                                />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              className="viewButton"
                              onClick={() => handleGridClick(4)}
                            >
                              <img
                                src={visiable}
                                alt="visible"
                                className="icon"
                              />
                            </IconButton>
                          )}
                        </>
                      );
                    })()
                  )}
                </Box>
              </Box>

              {/* 5th Box */}
              <Box>
                <Box className="gridItem">
                  {formData.gridType5 === null ||
                  formData.gridType5 === "" ||
                  formData.gridType5 === "null" ? (
                    <IconButton
                      className="centerButton"
                      onClick={() => handleGridClick(5)}
                    >
                      <img
                        src={frameadd}
                        alt="visible"
                        className="custom-icon"
                      />
                    </IconButton>
                  ) : (
                    (() => {
                      let imgmedia = gallery;
                      if (formData.gridType5 === UPLOADTYPE.PDF)
                        imgmedia = pdf1;
                      else if (formData.gridType5 === UPLOADTYPE.VIDEO)
                        imgmedia = video1;
                      else if (formData.gridType5 === UPLOADTYPE.LINK)
                        imgmedia = link1;

                      return (
                        <>
                          <Box className="centeredContent">
                            <img
                              src={imgmedia}
                              alt="visible"
                              className="custom-gallery"
                            />
                          </Box>
                          {editingIndex !== -1 ? (
                            <>
                              <IconButton
                                className="editButton"
                                onClick={() => handleGridClick(5)}
                              >
                                <img src={edit} alt="edit" className="icon" />
                              </IconButton>
                              <IconButton
                                className="deleteButton"
                                onClick={() => handleClearGridByID(5)}
                              >
                                <img
                                  src={delete1}
                                  alt="delete"
                                  className="icon"
                                />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              className="viewButton"
                              onClick={() => handleGridClick(5)}
                            >
                              <img
                                src={visiable}
                                alt="visible"
                                className="icon"
                              />
                            </IconButton>
                          )}
                        </>
                      );
                    })()
                  )}
                </Box>
              </Box>

              {/* 6th Box */}

              <Box>
                <Box className="gridItem">
                  {formData.gridType6 === null ||
                  formData.gridType6 === "" ||
                  formData.gridType6 === "null" ? (
                    <IconButton
                      className="centerButton"
                      onClick={() => handleGridClick(6)}
                    >
                      <img
                        src={frameadd}
                        alt="visible"
                        className="custom-icon"
                      />
                    </IconButton>
                  ) : (
                    (() => {
                      let imgmedia = gallery;
                      if (formData.gridType6 === UPLOADTYPE.PDF)
                        imgmedia = pdf1;
                      else if (formData.gridType6 === UPLOADTYPE.VIDEO)
                        imgmedia = video1;
                      else if (formData.gridType6 === UPLOADTYPE.LINK)
                        imgmedia = link1;

                      return (
                        <>
                          <Box className="centeredContent">
                            <img
                              src={imgmedia}
                              alt="visible"
                              className="custom-gallery"
                            />
                          </Box>
                          {editingIndex !== -1 ? (
                            <>
                              <IconButton
                                className="editButton"
                                onClick={() => handleGridClick(6)}
                              >
                                <img src={edit} alt="edit" className="icon" />
                              </IconButton>
                              <IconButton
                                className="deleteButton"
                                onClick={() => handleClearGridByID(6)}
                              >
                                <img
                                  src={delete1}
                                  alt="delete"
                                  className="icon"
                                />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              className="viewButton"
                              onClick={() => handleGridClick(6)}
                            >
                              <img
                                src={visiable}
                                alt="visible"
                                className="icon"
                              />
                            </IconButton>
                          )}
                        </>
                      );
                    })()
                  )}
                </Box>
              </Box>

              {/* 7th Box */}
              <Box>
                <Box className="gridItem">
                  {formData.gridType7 === null ||
                  formData.gridType7 === "" ||
                  formData.gridType7 === "null" ? (
                    <IconButton
                      className="centerButton"
                      onClick={() => handleGridClick(7)}
                    >
                      <img
                        src={frameadd}
                        alt="visible"
                        className="custom-icon"
                      />
                    </IconButton>
                  ) : (
                    (() => {
                      let imgmedia = gallery;
                      if (formData.gridType7 === UPLOADTYPE.PDF)
                        imgmedia = pdf1;
                      else if (formData.gridType7 === UPLOADTYPE.VIDEO)
                        imgmedia = video1;
                      else if (formData.gridType7 === UPLOADTYPE.LINK)
                        imgmedia = link1;

                      return (
                        <>
                          <Box className="centeredContent">
                            <img
                              src={imgmedia}
                              alt="visible"
                              className="custom-gallery"
                            />
                          </Box>
                          {editingIndex !== -1 ? (
                            <>
                              <IconButton
                                className="editButton"
                                onClick={() => handleGridClick(7)}
                              >
                                <img src={edit} alt="edit" className="icon" />
                              </IconButton>
                              <IconButton
                                className="deleteButton"
                                onClick={() => handleClearGridByID(7)}
                              >
                                <img
                                  src={delete1}
                                  alt="delete"
                                  className="icon"
                                />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              className="viewButton"
                              onClick={() => handleGridClick(7)}
                            >
                              <img
                                src={visiable}
                                alt="visible"
                                className="icon"
                              />
                            </IconButton>
                          )}
                        </>
                      );
                    })()
                  )}
                </Box>
              </Box>

              {/* 8th Box */}
              <Box>
                <Box className="gridItem">
                  {formData.gridType8 === null ||
                  formData.gridType8 === "" ||
                  formData.gridType8 === "null" ? (
                    <IconButton
                      className="centerButton"
                      onClick={() => handleGridClick(8)}
                    >
                      <img
                        src={frameadd}
                        alt="visible"
                        className="custom-icon"
                      />
                    </IconButton>
                  ) : (
                    (() => {
                      let imgmedia = gallery;
                      if (formData.gridType8 === UPLOADTYPE.PDF)
                        imgmedia = pdf1;
                      else if (formData.gridType8 === UPLOADTYPE.VIDEO)
                        imgmedia = video1;
                      else if (formData.gridType8 === UPLOADTYPE.LINK)
                        imgmedia = link1;

                      return (
                        <>
                          <Box className="centeredContent">
                            <img
                              src={imgmedia}
                              alt="visible"
                              className="custom-gallery"
                            />
                          </Box>
                          {editingIndex !== -1 ? (
                            <>
                              <IconButton
                                className="editButton"
                                onClick={() => handleGridClick(8)}
                              >
                                <img src={edit} alt="edit" className="icon" />
                              </IconButton>
                              <IconButton
                                className="deleteButton"
                                onClick={() => handleClearGridByID(8)}
                              >
                                <img
                                  src={delete1}
                                  alt="delete"
                                  className="icon"
                                />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              className="viewButton"
                              onClick={() => handleGridClick(8)}
                            >
                              <img
                                src={visiable}
                                alt="visible"
                                className="icon"
                              />
                            </IconButton>
                          )}
                        </>
                      );
                    })()
                  )}
                </Box>
              </Box>
              {/* 9th Box */}
              <Box>
                <Box className="gridItem">
                  {formData.gridType9 === null ||
                  formData.gridType9 === "" ||
                  formData.gridType9 === "null" ? (
                    <IconButton
                      className="centerButton"
                      onClick={() => handleGridClick(9)}
                    >
                      <img
                        src={frameadd}
                        alt="visible"
                        className="custom-icon"
                      />
                    </IconButton>
                  ) : (
                    (() => {
                      let imgmedia = gallery;
                      if (formData.gridType9 === UPLOADTYPE.PDF)
                        imgmedia = pdf1;
                      else if (formData.gridType9 === UPLOADTYPE.VIDEO)
                        imgmedia = video1;
                      else if (formData.gridType9 === UPLOADTYPE.LINK)
                        imgmedia = link1;

                      return (
                        <>
                          <Box className="centeredContent">
                            <img
                              src={imgmedia}
                              alt="visible"
                              className="custom-gallery"
                            />
                          </Box>
                          {editingIndex !== -1 ? (
                            <>
                              <IconButton
                                className="editButton"
                                onClick={() => handleGridClick(9)}
                              >
                                <img src={edit} alt="edit" className="icon" />
                              </IconButton>
                              <IconButton
                                className="deleteButton"
                                onClick={() => handleClearGridByID(9)}
                              >
                                <img
                                  src={delete1}
                                  alt="delete"
                                  className="icon"
                                />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              className="viewButton"
                              onClick={() => handleGridClick(9)}
                            >
                              <img
                                src={visiable}
                                alt="visible"
                                className="icon"
                              />
                            </IconButton>
                          )}
                        </>
                      );
                    })()
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {/* Action button ////////////////////////// */}
      <Stack
        className="action-button"
        direction="row"
        spacing={2}
        justifyContent="flex-end"
      >
        {editingIndex !== -1 && (
          <Button onClick={() => handleClear()} className="clear-button1">
            Clear
          </Button>
        )}

        <Button onClick={handleCancel} className="cancel-button">
          Cancel
        </Button>
        {editingIndex !== -1 && (
          <Button
            disabled={error != null || viderror != null}
            onClick={handleSave}
            className="save-button"
          >
            {editingIndex !== null ? "Update" : "Save"}{" "}
          </Button>
        )}
      </Stack>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        {openImageDialog && (
          <ImageGalleryDialog
            open={openImageDialog}
            onClose={() => setopenImageDialog(false)}
            oldMedia={oldMedia ?? ""}
            setOldMedia={setOldMedia}
            oldThumbnail={oldThumbnail ?? ""}
            setOldThumbnail={setOldThumbnail}
            gridType={gridType ?? ""}
            setGridType={setGridType}
            newMedia={newMedia ?? ""}
            setNewMedia={setNewMedia}
            newThumbnail={newThumbnail ?? ""}
            setNewThumbnail={setNewThumbnail}
            setgridTitle={setgridTitle}
            gridTitle={gridTitle}
          />
        )}

        {openVideoDialog && (
          <VideoGalleryDialog
            open={openVideoDialog}
            onClose={() => setopenVideoDialog(false)}
            oldMedia={oldMedia ?? ""}
            setOldMedia={setOldMedia}
            oldThumbnail={oldThumbnail ?? ""}
            setOldThumbnail={setOldThumbnail}
            gridType={gridType ?? ""}
            setGridType={setGridType}
            newMedia={newMedia ?? ""}
            setNewMedia={setNewMedia}
            newThumbnail={newThumbnail ?? ""}
            setNewThumbnail={setNewThumbnail}
            setgridTitle={setgridTitle}
            gridTitle={gridTitle}
          />
        )}
        {openPDFDialog && (
          <PDFMediaDialog
            open={openPDFDialog}
            onClose={() => setopenPDFDialog(false)}
            oldMedia={oldMedia ?? ""}
            setOldMedia={setOldMedia}
            oldThumbnail={oldThumbnail ?? ""}
            setOldThumbnail={setOldThumbnail}
            gridType={gridType ?? ""}
            setGridType={setGridType}
            newMedia={newMedia ?? ""}
            setNewMedia={setNewMedia}
            newThumbnail={newThumbnail ?? ""}
            setNewThumbnail={setNewThumbnail}
            setgridTitle={setgridTitle}
            gridTitle={gridTitle}
          />
        )}
        {openPDFDialog && (
          <PDFMediaDialog
            open={openPDFDialog}
            onClose={() => setopenPDFDialog(false)}
            oldMedia={oldMedia ?? ""}
            setOldMedia={setOldMedia}
            oldThumbnail={oldThumbnail ?? ""}
            setOldThumbnail={setOldThumbnail}
            gridType={gridType ?? ""}
            setGridType={setGridType}
            newMedia={newMedia ?? ""}
            setNewMedia={setNewMedia}
            newThumbnail={newThumbnail ?? ""}
            setNewThumbnail={setNewThumbnail}
            setgridTitle={setgridTitle}
            gridTitle={gridTitle}
          />
        )}
        {openLinkDialog && (
          <LinkGalleryDialog
            open={openLinkDialog}
            onClose={() => setopenLinkDialog(false)}
            oldMedia={oldMedia ?? ""}
            setOldMedia={setOldMedia}
            oldThumbnail={oldThumbnail ?? ""}
            setOldThumbnail={setOldThumbnail}
            gridType={gridType ?? ""}
            setGridType={setGridType}
            newMedia={newMedia ?? ""}
            setNewMedia={setNewMedia}
            newThumbnail={newThumbnail ?? ""}
            setNewThumbnail={setNewThumbnail}
            setgridTitle={setgridTitle}
            gridTitle={gridTitle}
          />
        )}
      </Box>
    </Dialog>
  );
};

export default PublishIndiaFormDialog;
